/**
 * 从系统地区树拼出「省 市 区」文案（与后端 AreaUtils.format 展示一致）
 */
export function formatAreaNameFromTree(
  areaTree: any[] | undefined | null,
  areaId?: number | null
): string {
  if (areaId == null || !areaTree?.length) {
    return ''
  }
  const path: string[] = []
  const dfs = (nodes: any[], trail: string[]): boolean => {
    for (const node of nodes || []) {
      const name = String(node?.name || node?.label || '').trim()
      const next = name ? [...trail, name] : trail
      const id = node?.id ?? node?.value
      if (Number(id) === Number(areaId)) {
        path.push(...next)
        return true
      }
      if (dfs(node?.children || [], next)) {
        return true
      }
    }
    return false
  }
  dfs(areaTree, [])
  return path.join(' ')
}

/** 退货地址一行展示：省市区 + 详细地址 */
export function formatReturnAddressLine(
  areaTree: any[] | undefined | null,
  info: {
    returnAreaId?: number | null
    returnAreaName?: string | null
    returnDetailAddress?: string | null
  }
): string {
  const area =
    String(info.returnAreaName || '').trim() ||
    formatAreaNameFromTree(areaTree, info.returnAreaId)
  return [area, info.returnDetailAddress].filter(Boolean).join(' ')
}
